import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-2 gap-6" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "text-gray-lp-600" }, "(Setiap Hari)", -1)
const _hoisted_4 = { class: "space-y-2 pt-2" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "text-12px font-normal text-gray-lp-500 max-w-md" }, " Klik tombol di bawah ini untuk mengaktifkan atau menonaktifkan status ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    onBack: _ctx.goBack,
    title: _ctx.title,
    fullPage: !_ctx.isDetail && !_ctx.isEdit,
    "vertical-separator": _ctx.isDetail,
    loading: _ctx.detailEntities.loading,
    error: !!_ctx.detailEntities.message,
    errorType: _ctx.detailEntities.message,
    onTryAgain: _ctx.fetchDetail,
    subData: _ctx.subData,
    "leave-page-confirmation": _ctx.leavePageConfirmation,
    "onUpdate:leave-page-confirmation": _cache[17] || (_cache[17] = ($event: any) => (_ctx.leavePageConfirmation = $event)),
    onLeavePage: _ctx.onLeavePage
  }, {
    "top-right": _withCtx(() => [
      (!_ctx.isDetail)
        ? (_openBlock(), _createBlock(_component_lp_button, {
            key: 0,
            title: "Simpan",
            textColor: "white",
            onClick: _ctx.onConfirm,
            disabled: _ctx.isDisabled
          }, null, 8, ["onClick", "disabled"]))
        : _createCommentVNode("", true)
    ]),
    data: _withCtx(() => [
      _createVNode("div", {
        class: ["space-y-6 px-4 w-3/4", { 'w-11/12': _ctx.isEdit }]
      }, [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_DataWrapper, {
            label: "ID",
            asterisk: !_ctx.isDetail,
            class: "w-full",
            value: _ctx.detailData.id
          }, {
            default: _withCtx(() => [
              (!_ctx.isDetail)
                ? (_openBlock(), _createBlock(_component_LpInput, {
                    key: 0,
                    modelValue: _ctx.detailData.id,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.detailData.id = $event)),
                    disabled: ""
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["asterisk", "value"]),
          _createVNode(_component_DataWrapper, {
            label: "Nama Denda",
            asterisk: !_ctx.isDetail,
            class: "w-full",
            value: _ctx.detailData.name
          }, {
            default: _withCtx(() => [
              (!_ctx.isDetail)
                ? (_openBlock(), _createBlock(_component_LpInput, {
                    key: 0,
                    modelValue: _ctx.detailData.name,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.detailData.name = $event)),
                    disabled: ""
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["asterisk", "value"]),
          _createVNode(_component_DataWrapper, {
            label: "Berlaku Untuk",
            asterisk: !_ctx.isDetail,
            class: "w-full",
            value: _ctx.detailData.appliedTo
          }, {
            default: _withCtx(() => [
              (!_ctx.isDetail)
                ? (_openBlock(), _createBlock(_component_LpInput, {
                    key: 0,
                    modelValue: _ctx.detailData.appliedTo,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.detailData.appliedTo = $event)),
                    disabled: ""
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["asterisk", "value"]),
          _createVNode(_component_DataWrapper, {
            label: "Tipe Partner",
            class: "w-full",
            value: _ctx.detailData.partnerType,
            asterisk: !_ctx.isDetail
          }, {
            default: _withCtx(() => [
              (!_ctx.isDetail)
                ? (_openBlock(), _createBlock(_component_LpInput, {
                    key: 0,
                    modelValue: _ctx.detailData.partnerType,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.detailData.partnerType = $event)),
                    disabled: ""
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["value", "asterisk"]),
          _createVNode(_component_DataWrapper, {
            label: "Deskripsi Denda",
            class: "w-full col-span-2",
            value: _ctx.detailData.description,
            asterisk: !_ctx.isDetail
          }, {
            default: _withCtx(() => [
              (_ctx.isEdit)
                ? (_openBlock(), _createBlock(_component_LpInput, {
                    key: 0,
                    modelValue: _ctx.detailData.description,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.detailData.description = $event)),
                    type: "textarea",
                    placeholder: "Masukkan deskripsi",
                    maxLength: "220"
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["value", "asterisk"]),
          _createVNode(_component_DataWrapper, {
            label: "Persentase Denda H+1",
            asterisk: !_ctx.isDetail,
            class: "w-full",
            value: `${_ctx.formatDecimal(_ctx.detailData.percentagePenalty)}%`,
            tooltipDescription: 
              _ctx.isEdit
                ? 'Persentase denda yang dikenakan jika saldo minus lewat dari hari pertama'
                : ''
            
          }, {
            default: _withCtx(() => [
              (!_ctx.isDetail)
                ? (_openBlock(), _createBlock(_component_LpInput, _mergeProps({
                    key: 0,
                    placeholder: "Masukkan persentase denda H+1",
                    modelValue: _ctx.detailData.percentagePenalty,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.detailData.percentagePenalty = $event)),
                    onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onChangePercentage($event, 'percentagePenalty'))),
                    error: _ctx.errors.percentagePenalty
                  }, _ctx.errorData), null, 16, ["modelValue", "error"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["asterisk", "value", "tooltipDescription"]),
          _createVNode(_component_DataWrapper, {
            label: "Persentase Denda Setelah H+1",
            asterisk: !_ctx.isDetail,
            class: "w-full",
            value: `${_ctx.formatDecimal(_ctx.detailData.percentageAfterPenalty)}%`,
            tooltipDescription: 
              _ctx.isEdit
                ? 'Persentase denda yang dikenakan jika saldo minus memasuki hari kedua dan selanjutnya'
                : ''
            
          }, {
            default: _withCtx(() => [
              (!_ctx.isDetail)
                ? (_openBlock(), _createBlock(_component_LpInput, _mergeProps({
                    key: 0,
                    placeholder: "Masukkan persentase denda setelah H+1",
                    modelValue: _ctx.detailData.percentageAfterPenalty,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.detailData.percentageAfterPenalty = $event)),
                    onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onChangePercentage($event, 'percentageAfterPenalty'))),
                    error: _ctx.errors.percentageAfterPenalty
                  }, _ctx.errorData), null, 16, ["modelValue", "error"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["asterisk", "value", "tooltipDescription"]),
          _createVNode(_component_DataWrapper, {
            label: "Batas Waktu POS Top Up Saldo",
            asterisk: !_ctx.isDetail,
            class: "w-full",
            tooltipDescription: _ctx.isEdit ? 'Berlaku setiap hari ' : ''
          }, {
            default: _withCtx(() => [
              (_ctx.isDetail)
                ? (_openBlock(), _createBlock("span", _hoisted_2, [
                    _createTextVNode(_toDisplayString(_ctx.cutOffTimeFormat) + " ", 1),
                    _hoisted_3
                  ]))
                : (_openBlock(), _createBlock(_component_Datepicker, {
                    key: 1,
                    modelValue: _ctx.detailData.cutOffTime,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.detailData.cutOffTime = $event)),
                    showDatePicker: false,
                    showTimePicker: "",
                    manualInput: "",
                    showChevron: false,
                    placeholder: "06:00",
                    setDefaultDate: _ctx.isEdit,
                    customClassTime: "w-full mt-1.5"
                  }, null, 8, ["modelValue", "setDefaultDate"]))
            ]),
            _: 1
          }, 8, ["asterisk", "tooltipDescription"]),
          _createVNode(_component_DataWrapper, {
            label: "Total Maks. Saldo Minus Per Kota",
            asterisk: !_ctx.isDetail,
            class: "w-full",
            value: _ctx.maxMinusBalanceFormat,
            tooltipDescription: 
              _ctx.isEdit
                ? 'Maksimal saldo minus dihitung berdasarkan akumulasi POS di satu kota '
                : ''
            
          }, {
            default: _withCtx(() => [
              (!_ctx.isDetail)
                ? (_openBlock(), _createBlock(_component_LpInput, {
                    key: 0,
                    placeholder: "Masukkan total maks. saldo minus per kota",
                    modelValue: _ctx.detailData.maxMinusBalance,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.detailData.maxMinusBalance = $event)),
                    format: _ctx.formatInputMoneyWithDecimal,
                    prefix: "IDR",
                    onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onChangeValue($event, 'maxMinusBalance'))),
                    error: _ctx.errors.maxMinusBalance,
                    errorIcon: false,
                    errorCaption: "Min. 0"
                  }, null, 8, ["modelValue", "format", "error"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["asterisk", "value", "tooltipDescription"]),
          _createVNode(_component_DataWrapper, {
            label: "Termasuk Hari Minggu & Libur Nasional",
            asterisk: !_ctx.isDetail,
            class: "w-full",
            value: _ctx.includeDayOffFormat
          }, {
            default: _withCtx(() => [
              (!_ctx.isDetail)
                ? (_openBlock(), _createBlock(_component_CustomDropdown, {
                    key: 0,
                    options: _ctx.includeDayOffListData,
                    selectedItem: _ctx.detailData.includeDayOffData,
                    "onUpdate:selectedItem": _cache[13] || (_cache[13] = ($event: any) => (_ctx.detailData.includeDayOffData = $event)),
                    placeholder: "Termasuk hari minggu & libur nasional",
                    class: "mt-1.5"
                  }, null, 8, ["options", "selectedItem"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["asterisk", "value"]),
          _createVNode(_component_DataWrapper, {
            label: "Tipe Embargo COD",
            asterisk: !_ctx.isDetail,
            class: "w-full",
            value: _ctx.embargoCodTypeFormat,
            customStyleValue: "capitalize"
          }, {
            default: _withCtx(() => [
              (!_ctx.isDetail)
                ? (_openBlock(), _createBlock(_component_MultipleSelectSearch, {
                    key: 0,
                    options: _ctx.embargoCodTypeData,
                    modelValue: _ctx.detailData.embargoCodTypeData,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.detailData.embargoCodTypeData = $event)),
                    keyName: "name",
                    keyValue: "value",
                    placeholder: "Ketik atau pilih tipe embargo COD",
                    class: "mt-1.5",
                    onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onChangeValue($event, 'embargoCodType'))),
                    error: _ctx.errors.embargoCodType,
                    errorIcon: false,
                    errorCaption: "Min. 1 tipe"
                  }, null, 8, ["options", "modelValue", "error"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["asterisk", "value"]),
          (!_ctx.isDetail)
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 0,
                label: "Status Denda Saldo Minus",
                class: "col-span-2"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createVNode(_component_Toggle, {
                      "onUpdate:modelValue": [
                        _ctx.onClickToggleStatus,
                        _cache[16] || (_cache[16] = ($event: any) => (_ctx.detailData.statusData = $event))
                      ],
                      modelValue: _ctx.detailData.statusData,
                      textActive: "Aktif",
                      textInactive: "Tidak Aktif"
                    }, null, 8, ["onUpdate:modelValue", "modelValue"])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["onBack", "title", "fullPage", "vertical-separator", "loading", "error", "errorType", "onTryAgain", "subData", "leave-page-confirmation", "onLeavePage"]))
}